module.exports = __webpack_public_path__ + "static/media/home_grid_item_5.133cf3c0.png";